// extracted by mini-css-extract-plugin
export default {"bannerComponent":"Pk-z","red":"Qk-z","calloutlink":"Rk-z","headerTopBanner":"Sk-z","bgcolorRed":"Tk-z","headerTopCallout":"Uk-z","searchBanner":"Vk-z","hideMobile":"Wk-z"};